import React from 'react'

export default function IcoCheck( props ) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.6"
      viewBox="0 0 24 24"
      { ...props }
    >
      <path d="M4.5 12.5l5 5 10-11" />
    </svg>
  )
}
